import moment from "moment";
import { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import API from "../../common/API";
import Settings from "../../common/Settings";

const RecordSalarios = (props: any) => {
    const { id } = props;
    const [records, setRecords] = useState<any>([]);
    const { t } = useTranslation();

    const bindRecords = async () => {
        try {
            const response = await API.getAction(`salario/list?cedula=${id}`);
            if (response.status === 200) {
                setRecords(response.data.response || []);
            } else {
                console.error("Error fetching salarios records:", response.statusText);
            }
        } catch (error) {
            console.error("Error fetching salarios records:", error);
        }
    }

    useEffect(() => {
        if (id) {
            bindRecords();
        }
    }
        , [id]);
    if (records.length === 0) {
        return null;
    }

    const formatMoney = (salarioIsr: any): import("react").ReactNode => {
        if (typeof salarioIsr !== "number") {
            return "-";
        }
        return salarioIsr.toLocaleString("es-DO", {
            style: "currency",
            currency: "DOP",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
    }

    const groupedRecords = records.reduce((acc, item) => {
        const key = item.empleadorNombre || t("Sin institución")
        if (!acc[key]) {
            acc[key] = []
        }
        acc[key].push(item)
        return acc
    }, {} as Record<string, any[]>)

    const summarizedRecords = Object.keys(groupedRecords)
        .map(key => {
            const items = groupedRecords[key]
                .filter(x => x.fechaSalario)
                .sort(
                    (a, b) =>
                        new Date(a.fechaSalario).getTime() -
                        new Date(b.fechaSalario).getTime(),
                )
            const first = items[0]
            const last = items[items.length - 1]
            const startYear = first
                ? moment(first.fechaSalario).format("YYYY")
                : "-"
            const endYear = last
                ? moment(last.fechaSalario).format("YYYY")
                : "-"
            const lastSalary = last?.salario ?? null
            return {
                empleadorNombre: key,
                startYear,
                endYear,
                lastSalary,
                lastDate: last?.fechaSalario,
            }
        })
        .sort(
            (a, b) =>
                new Date(a.lastDate ?? 0).getTime() -
                new Date(b.lastDate ?? 0).getTime(),
        )

    return (
        <>
            <Card className="my-4">
                <Card.Header className="display-4">
                    {t("Antecedentes Laborales")}
                </Card.Header>
                <Card.Body className="p-3">
                    <div
                        className="d-flex align-items-stretch gap-3"
                        style={{
                            overflowX: "auto",
                            paddingBottom: "0.5rem",
                        }}
                    >
                        {summarizedRecords.map((item, index) => {
                            return (
                                <div
                                    key={`${item.empleadorNombre}-${item.startYear}-${item.endYear}-${index}`}
                                    className="d-flex flex-column align-items-center"
                                    style={{ minWidth: "220px" }}
                                >
                                    <div
                                        className="fw-bold text-primary"
                                        style={{ fontSize: "1.1rem" }}
                                    >
                                        {item.startYear} - {item.endYear}
                                    </div>
                                    <div
                                        className="rounded-circle bg-primary"
                                        style={{ width: "12px", height: "12px" }}
                                    ></div>
                                    <div
                                        className="bg-primary"
                                        style={{ width: "2px", height: "18px" }}
                                    ></div>
                                    <div
                                        className="card shadow-sm w-100"
                                        style={{ borderRadius: "12px" }}
                                    >
                                        <div className="card-body p-3">
                                            <div className="fw-semibold">
                                                {item.empleadorNombre}
                                            </div>
                                            <div className="text-success mt-2">
                                                {formatMoney(item.lastSalary)}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </Card.Body>
            </Card>
        </>
    );
};

export default RecordSalarios;